import { Component, inject, Input, input } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { TimeService } from '../services/time.service';

@UntilDestroy()
@Component({
  template: '',
})
export class BaseTimerComponent {

  readonly timeLeft = input<Date>(undefined);

  public timeLive: any;

  public time: TimeService = inject(TimeService);

  constructor() {
  }

  public resolveTimer() {
    this.time.currentDate$()
      .pipe(
        untilDestroyed(this),
      ).subscribe(() => {
      this.timeLive = this.time.timeDiff(this.timeLeft());
    });
  }

}
